var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c('LoadingContainer'):_c('FormLayout',{attrs:{"initial":_vm.contentJob.attributes,"errors":_vm.errors,"company-id":_vm.contentJob.attributes.company_id,"content-job-regions":_vm.contentJobRegions,"edit":true,"url":_vm.portal.attributes.base_url + '/' + _vm.contentJob.attributes.path},on:{"submit":_vm.submit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }